export enum ImagesEnum {
  LOGO = "/images/aplik.png",
  LOGO_WHITE = "/images/aplik_white.png",
  HERO = "/images/banner_overlay.svg",
  DAM = "/images/priehrada.jpg",
  ZELIEZOVCE = "/images/zeliezovce.jpg",
  GOTKO = "/images/gotko.jpg",
  SECTION_WITH_IMAGE = "/images/ČOV 2.png",
  PANELY = "/images/panely.jpg",
  PRIEMYSEL = "/images/stroj.jpg",
  FONTANY = "/images/fontana.jpg",
  ENERGETIKA = "/images/energetika.jpg",
  SERVIS_A_TECHNICKA_SPRAVA = "/images/inzinier2.jpg",
  VODARENSTVO = "/images/vodarenstvo.jpg",

  // Partner logos
  BVSAS = "/images/partners/bvs-logo.png",
  CORPLEX = "/images/partners/corplex.webp",
  FORTISCHEM = "/images/partners/fortischem.svg",
  MONDELEZ = "/images/partners/Mondelez_International_Logo.jpg",
  OVS = "/images/partners/ovs.webp",
  STVPS = "/images/partners/stvps.svg",
  POVS = "/images/partners/povs.png",
  SCVK = "/images/partners/scvk.svg",
  VETROPACK = "/images/partners/vetropack.svg",
  VODARNE = "/images/partners/vodarne.png",
  ZAMKA = "/images/partners/zamka.png",
  ZSVS = "/images/partners/zsvs.png",

  ABOUT_COMPANY_1 = "/images/Country_Winner.png",

  // PROJECTS PARTNER LOGOS
  HACH = "/images/projectPartners/hach.jpg",
  PHOENIX_CONTACT = "/images/projectPartners/phoenix_contact.jpg",
  SALTEK = "/images/projectPartners/saltek.jpg",
  SCHNEIDER_ELECTRIC = "/images/projectPartners/schneider_electric.jpg",
  SIEMENS = "/images/projectPartners/siemens.jpg",
  XYLEM = "/images/projectPartners/xylem.png",

  CENOVO = "/images/cenovo.jpg",
  CARBOPRAX = "/images/carboprax.jpg",

  HERO_VIDEO = "/videos/hero_video.mp4",
  CYBERSPACE_VIDEO = "/videos/cyberspace.mp4",

  // Gallery images for MVE Želiezovce project
  ZELIEZOVCE_1 = "/images/galleryImages/zeliezovce/MVE_ZELIEZOVCE_001.jpg",
  ZELIEZOVCE_2 = "/images/galleryImages/zeliezovce/MVE_ZELIEZOVCE_002.jpg",
  ZELIEZOVCE_3 = "/images/galleryImages/zeliezovce/MVE_ZELIEZOVCE_003.jpg",
  ZELIEZOVCE_4 = "/images/galleryImages/zeliezovce/MVE_ZELIEZOVCE_004.jpg",
  ZELIEZOVCE_5 = "/images/galleryImages/zeliezovce/MVE_ZELIEZOVCE_005.jpg",
  ZELIEZOVCE_6 = "/images/galleryImages/zeliezovce/MVE_ZELIEZOVCE_006.jpg",

  // Gallery images for Harmanec
  HARMANEC_1 = "/images/galleryImages/harmanec/MVE_Harmanec_001.jpg",
  HARMANEC_2 = "/images/galleryImages/harmanec/MVE_Harmanec_002.jpg",
  HARMANEC_3 = "/images/galleryImages/harmanec/MVE_Harmanec_003.jpg",
  HARMANEC_4 = "/images/galleryImages/harmanec/MVE_Harmanec_004.jpg",

  // Gallery images for Fontana Gotko
  DRUZBA_1 = "/images/galleryImages/gotko/druzba_001.jpg",
  DRUZBA_2 = "/images/galleryImages/gotko/druzba_002.jpg",
  DRUZBA_3 = "/images/galleryImages/gotko/druzba_003.jpg",
  DRUZBA_4 = "/images/galleryImages/gotko/druzba_004.jpg",
  DRUZBA_5 = "/images/galleryImages/gotko/druzba_005.jpg",
  DRUZBA_6 = "/images/galleryImages/gotko/druzba_006.jpg",
  DRUZBA_7 = "/images/galleryImages/gotko/druzba_007.jpg",
  DRUZBA_8 = "/images/galleryImages/gotko/druzba_008.jpg",
  DRUZBA_10 = "/images/galleryImages/gotko/Font-družba.jpeg",
  DRUZBA_11 = "/images/galleryImages/gotko/druzba_9.jpg",
  DRUZBA_12 = "/images/galleryImages/gotko/druzba_10.jpg",
  DRUZBA_13 = "/images/galleryImages/gotko/druzba_11.jpg",
  DRUZBA_14 = "/images/galleryImages/gotko/druzba_12.jpg",
  DRUZBA_15 = "/images/galleryImages/gotko/druzba_13.jpg",

  // Gallery images for Mondelez project
  MONDELEZ_MAIN = "/images/galleryImages/mondelez/Mondelez.jpg",
  MONDELEZ_CALENDAR_TREND = "/images/galleryImages/mondelez/Calendar_trend_week_report.png",
  MONDELEZ_LOAD_PROFILE_KVAR = "/images/galleryImages/mondelez/Load_Profile_Report_kVAR.png",
  MONDELEZ_LOAD_PROFILE_KW = "/images/galleryImages/mondelez/Load_Profile_Report_kW.png",
  MONDELEZ_LOAD_PROFILE_TABLE = "/images/galleryImages/mondelez/Load_Profile_Report_table.png",
  MONDELEZ_MULTI_DEVICE_USAGE_1 = "/images/galleryImages/mondelez/MultiDeviceUsageReport_1.png",
  MONDELEZ_MULTI_DEVICE_USAGE_2 = "/images/galleryImages/mondelez/MultiDeviceUsageReport_2.png",
  MONDELEZ_PM5300_VOLTS_AMPS = "/images/galleryImages/mondelez/PM5300_01volts_amps.png",
  MONDELEZ_PM5300_POWER_QUALITY = "/images/galleryImages/mondelez/PM5300_06power_quality.png",
  MONDELEZ_PM5300_HARMONICS = "/images/galleryImages/mondelez/PM5300_07harmonics.png",
  MONDELEZ_PM5300_HARMONICS_MIN_MAX = "/images/galleryImages/mondelez/PM5300_08harmonics_min_max.png",
  MONDELEZ_PM5300_ENERGY_DMD = "/images/galleryImages/mondelez/PM5300_09energy_dmd.png",
  MONDELEZ_PM5300_DEMAND_GRAPH = "/images/galleryImages/mondelez/PM5300_11demand_graph.png",
  MONDELEZ_PM5300_ALARMS = "/images/galleryImages/mondelez/PM5300_12alarms.png",
  MONDELEZ_PM5300_DIAGNOSTICS = "/images/galleryImages/mondelez/PM5300_13diagnostics.png",
  MONDELEZ_PM5300_METER_EVENTS = "/images/galleryImages/mondelez/PM5300_14meter_events.png",
  MONDELEZ_DASH2 = "/images/galleryImages/mondelez/dash2.jpg",
  MONDELEZ_DIAG_NETWORK = "/images/galleryImages/mondelez/diag_network.jpg",

  // Gallery images for Fortischem project
  FORTISCHEM_1 = "/images/galleryImages/fortischem/20241030_100138.jpg",
  FORTISCHEM_2 = "/images/galleryImages/fortischem/20250122_151222.jpg",
  FORTISCHEM_3 = "/images/galleryImages/fortischem/drvenie vapna.jpg",
  FORTISCHEM_4 = "/images/galleryImages/fortischem/fortischem-1.png",

  // Gallery images for ZAMKA project
  ZAMKA_1 = "/images/galleryImages/zamka/20170622_pohlad turbina.jpg",
  ZAMKA_2 = "/images/galleryImages/zamka/20230324_141042.jpg",
  ZAMKA_3 = "/images/galleryImages/zamka/20240802_121316.jpg",
  ZAMKA_4 = "/images/galleryImages/zamka/Vynaska 2.jpeg",
  ZAMKA_5 = "/images/galleryImages/zamka/zamkovskeho-chata.jpg",

  // Gallery images for Podbrezova project
  PODBREZOVA_1 = "/images/galleryImages/podbrezova/MAX_192_1754644838.jpg",
  PODBREZOVA_2 = "/images/galleryImages/podbrezova/MAX_192_1754644857.jpg",
  PODBREZOVA_3 = "/images/galleryImages/podbrezova/MAX_192_1754644867.jpg",

  // Gallery images for Senec project
  SENEC_1 = "/images/galleryImages/senec/20210423_084419.jpg",
  SENEC_2 = "/images/galleryImages/senec/20210423_084422.jpg",
  SENEC_3 = "/images/galleryImages/senec/20210423_084423.jpg",
  SENEC_4 = "/images/galleryImages/senec/20251120_101336.jpg",
  SENEC_5 = "/images/galleryImages/senec/20251120_101338.jpg",
  SENEC_6 = "/images/galleryImages/senec/20251120_102521.jpg",
  SENEC_7 = "/images/galleryImages/senec/20251120_102932.jpg",
  SENEC_8 = "/images/galleryImages/senec/20251120_103038.jpg",
  SENEC_9 = "/images/galleryImages/senec/20251120_103147.jpg",
  SENEC_10 = "/images/galleryImages/senec/20251120_104518.jpg",

  // Gallery images for Pruske
  PRUSKE_1 = "/images/galleryImages/pruske/20251205_112045.jpg",
  PRUSKE_2 = "/images/galleryImages/pruske/20251205_112046.jpg",
  PRUSKE_3 = "/images/galleryImages/pruske/20251205_112204.jpg",
  PRUSKE_4 = "/images/galleryImages/pruske/20251205_112525.jpg",
  PRUSKE_5 = "/images/galleryImages/pruske/20251205_112736.jpg",
  PRUSKE_6 = "/images/galleryImages/pruske/20251205_112933.jpg",
  PRUSKE_7 = "/images/galleryImages/pruske/20251205_113322.jpg",
  PRUSKE_8 = "/images/galleryImages/pruske/20251205_114222.jpg",
  PRUSKE_9 = "/images/galleryImages/pruske/20251205_114641.jpg",
  PRUSKE_10 = "/images/galleryImages/pruske/20251205_115343.jpg",
  PRUSKE_11 = "/images/galleryImages/pruske/20251205_115614.jpg",
  PRUSKE_12 = "/images/galleryImages/pruske/20251205_122745.jpg",
  PRUSKE_13 = "/images/galleryImages/pruske/20251205_122831.jpg",
  PRUSKE_14 = "/images/galleryImages/pruske/20251205_134561.jpg",
  PRUSKE_15 = "/images/galleryImages/pruske/20251205_137248.jpg",

  // Gallery images for Liscí vrch
  LISCI_VRCH_1 = "/images/galleryImages/lisciVrch/DSC_0056.JPG",
  LISCI_VRCH_2 = "/images/galleryImages/lisciVrch/DSC_0057.JPG",
  LISCI_VRCH_3 = "/images/galleryImages/lisciVrch/DSC_0064.JPG",
  LISCI_VRCH_4 = "/images/galleryImages/lisciVrch/DSC_0069.JPG",

  // Gallery images for Orion
  ORION_1 = "/images/galleryImages/orion/20251119_115219.jpg",
  ORION_2 = "/images/galleryImages/orion/20251119_115246.jpg",
}
